"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ServiceException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ServiceException"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var IOWS_DOMAINS = {
  'www.ikea.com': 'iows.ikea.com',
  'www2.ikea.com': 'iows.ikea.com',
  'www.cte.ikeadt.com': 'iows.cte.ikeadt.com',
  'www.ctem.ikeadt.com': 'iows.ctem.ikeadt.com',
  'www.ctef2.ikeadt.com': 'iows.ctef2.ikeadt.com',
  'www.ppe.ikeadt.com': 'iows.ppe.ikeadt.com',
  'www2.cte.ikeadt.com': 'iows2.cte.ikeadt.com',
  'www2.ctem.ikeadt.com': 'iows2.ctem.ikeadt.com',
  'www2.ctef2.ikeadt.com': 'iows2.ctef2.ikeadt.com',
  'www2.ppe.ikeadt.com': 'iows2.ppe.ikeadt.com',
  'm.ikea.com': 'iows.ikea.com',
  'm2.ikea.com': 'iows.ikea.com',
  'm2.ikea.cn': 'iows.ikea.cn',
  'm.cte.ikeadt.com': 'iows.cte.ikeadt.com',
  'm.ctem.ikeadt.com': 'iows.ctem.ikeadt.com',
  'm.ctef2.ikeadt.com': 'iows.ctef2.ikeadt.com',
  'm.ppe.ikeadt.com': 'iows.ppe.ikeadt.com'
};
/**
 * This class is used to provide utility functions for services.
 */

var ServiceUrlUtility = /*#__PURE__*/function () {
  function ServiceUrlUtility() {
    _classCallCheck(this, ServiceUrlUtility);
  }

  _createClass(ServiceUrlUtility, null, [{
    key: "getFallbackLocale",

    /**
     * Returns a fallback locale.
     *
     * @returns {object} Service locale object.
     */
    value: function getFallbackLocale() {
      var fallbackLocale = this._getParameterByName('fallbackLocale');

      var fallbackLanguageCode, fallbackCountryCode;

      if (fallbackLocale && fallbackLocale.length === 5) {
        var locale = fallbackLocale.toLowerCase().split('_');
        fallbackLanguageCode = locale[0];
        fallbackCountryCode = locale[1];
      } else {
        fallbackLocale = null;
      }

      if (fallbackLocale) {
        return {
          locale: fallbackLocale,
          countryCode: fallbackCountryCode,
          languageCode: fallbackLanguageCode
        };
      }

      return null;
    }
    /**
     * Returns the base URL.
     *
     * @returns {string} Base URL.
     */

  }, {
    key: "getBaseUrl",
    value: function getBaseUrl() {
      var host = window.location.hostname;
      var protocol = 'https://';

      if (IOWS_DOMAINS[host]) {
        return protocol + IOWS_DOMAINS[host];
      } else if (/(.ikea.cn)|(.ikeadt.cn)/.test(host)) {
        var parts = host.split('.');

        if (['www', 'm'].indexOf(parts[0]) > -1) {
          parts[0] = 'iows';
        }

        return protocol + parts.join('.');
      }

      return '';
    }
    /**
     * Returns the WPRW base URL.
     *
     * @returns {string} Base URL.
     */

  }, {
    key: "getWprwBaseUrl",
    value: function getWprwBaseUrl() {
      var host = window.location.hostname;

      if (!this.usingProxy(host)) {
        if (host.includes('ikea.com') || host.includes('ikea.cn') || host.includes('ikeadt.com')) {
          if (host.startsWith('m.')) {
            host = host.replace('m.', '');
          } else if (host.startsWith('m2.')) {
            host = host.replace('m2.', '');
          } else if (host.startsWith('www.')) {
            host = host.replace('www.', '');
          } else if (host.startsWith('www2.')) {
            host = host.replace('www2.', '');
          }

          host = 'ww8.' + host;
          return 'https://' + host;
        }

        return 'https://ww8.ikea.com';
      }

      return '';
    }
    /**
     * Returns the locale based on path.
     *
     * @throws ServiceException
     * @param {string} [path] Optional URI path. "location.pathname" will be used by default.
     * @returns {object} Locale object.
     */

  }, {
    key: "getLocaleFromPath",
    value: function getLocaleFromPath() {
      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var localePath = path !== null ? path : window.location.pathname;
      var choices = localePath.match(/\/\w{2}(?=\/|$)/g);

      if (choices.length !== 2) {
        // too few or many to choose from
        throw new _ServiceException.default('Unable to read locale from path. Path was not in a valid format.');
      }

      var matches = localePath.match(/\/(\w{2})\/(\w{2})(?:\/|$)/);
      return {
        countryCode: matches[1],
        languageCode: matches[2]
      };
    }
    /**
     * Checks if proxy is used.
     *
     * @param {string} host Host to use.
     * @returns {boolean} TRUE if proxy is used.
     */

  }, {
    key: "usingProxy",
    value: function usingProxy(host) {
      return /^(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})|(localhost)|(cybercomhosting)|(azurewebsites)/.test(host);
    }
    /**
     * Returns parameter based on name and location search.
     *
     * @param {string} name Parameter name.
     * @returns {string} Parameter.
     */

  }, {
    key: "_getParameterByName",
    value: function _getParameterByName(name) {
      var parameterName = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + parameterName + '=([^&#]*)');
      var results = regex.exec(location.search) || regex.exec(this._getParentLocationSearch());
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
    /**
     * Returns the parent window location search.
     *
     * @returns {string} Parameter.
     */

  }, {
    key: "_getParentLocationSearch",
    value: function _getParentLocationSearch() {
      var search = '';

      try {
        search = parent && parent.location && parent.location.search ? parent.location.search : '';
      } catch (err) {// Ignore error
      }

      return search;
    }
  }]);

  return ServiceUrlUtility;
}();

exports.default = ServiceUrlUtility;